// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__2Yj2o","choiceBoxes":"toolbarselects_choiceBoxes__3dTTt","simpleField":"toolbarselects_simpleField__28W_d"};